export default {
  landing: [
    {
      "name": "landing",
      "backgroundColor": "#000000",
      "noiseBg": true
    }
  ],
  portfolio: [
    {
      "name": "portfolio",
      "project": "portfolio",
      "projectId": 1,
      "backgroundColor": "#a63533",
      "titleColor": "#E6D47F",
      "descriptionColor": "#FEF8CD",
      "yearColor": "#E6D47F",
      "details": {
        "name": "Portfolio",
        "description": "Easily my toughest, but most valuable project, this portfolio allowed me to tie together my creativity on the front-end. I developed this website with the goal of creating something sleek and eye-catching, while showcasing my best work and myself. The result is a beautiful website that I am proud to share with you.",
        "role": "Front End",
        "year": "2019",
        "shape": "PSCircle.svg",
        "image": "logo_yellow.svg",
        "subImage": "personal-fire.png",
        "btnColor": "yellow",
        "techList": {
          "frontend": [
            "F0-React.svg",
            "F1-Redux.svg",
            "F2-Redux__Saga.svg",
            "L0-JavaScript.svg",
            "L2-HTML5.svg",
            // "L3-Sass.svg",
            "L4-CSS3.svg",
            // "F5-GreenSock.svg",
            // "F13-three_js.svg"
          ],
          // "backend": [
          //   "L1-CSharp.svg",
          //   "F3-ASP_NET__Core.png",
          //   "F4-Entity__Framework__Core.png",
          //   "T8-Microsoft__SQL__Server.svg"
          // ],
          "tech": [
            "T0-Google__Cloud__Platform.svg",
            // "T3-Docker.svg",
            // "T4-Kubernetes.svg",
            "T5-NGINX.svg",
            "F8-React__Testing__Library.png",
            "F9-DOM__Testing__Library.png",
            // "F6-XUnit.svg",
          ]
        },
        "codeUrl": "https://github.com/SanuKumar/sanuportfoliosite"
      },
      "shapes": [
        {
          "name": "portfolio",
          "id": 0,
          "pos": [
            [-70, -7, -60],
            [-45, 15, -15],
            [-9.5, -3, 7],
            [-3, 10, -1],
            [-4, -8.5, -4],
            [12.5, 5.5, 5],
            [18, -5, 2],
            [60, -15, -50],
          ],
          "scale": [0.4, 0.8, 0.2, 0.2, 0.1, 0.35, 0.35, 0.5],
          "materialId": 0
        }
      ]
    },
    {
      "name": "portfolio",
      "project": "filmbase",
      "projectId": 2,
      "backgroundColor": "#3A0A52",
      "titleColor": "#00FEFF",
      "descriptionColor": "#CEECFD",
      "yearColor": "#00FEFF",
      "details": {
        "name": "Mobile Store",
        "description": "E-commerce site where you can have several phone that you can buy.",
        "role": "Front End",
        "year": "2019",
        "shape": "PSSquare.svg",
        "image": "movie-candy-audience.png",
        "subImage": "movie-coupon.png",
        "btnColor": "blue",
        "techList": {
          "frontend": [
            "F0-React.svg",
            "F1-Redux.svg",
            "F2-Redux__Saga.svg",
            "L0-JavaScript.svg",
            "L2-HTML5.svg",
            // "L3-Sass.svg",
            "L4-CSS3.svg"
          ],
          "tech": [
            "T1-Firebase.svg",
            // "T13-Illustrator.svg",
            "T14-Photoshop.svg",
            "A0-YouTube__API.svg",
            // "A1-The__MovieDB__API.svg",
          ]
        },
        "projectUrl": "https://react-myphone-store.netlify.com/",
        "codeUrl": "https://github.com/SanuKumar/react-onlineStore"
      },
      "shapes": [
        {
          "name": "portfolio",
          "id": 1,
          "pos": [
            [-35, -20, -35],
            [-30, 8, -1],
            [-15, -5, 5],
            [-8, 10, -1],
            [13, 3, 5],
            [11, -5, 2],
            [15, 16, -18],
            [80, -45, -50],
          ],
          "scale": [0.4, 1, 0.5, 0.7, 0.4, 0.5, 0.5, 0.5],
          "materialId": 1
        }
      ]
    },
    {
      "name": "portfolio",
      "project": "loanapp",
      "projectId": 3,
      "backgroundColor": "#290ff0",
      "titleColor": "#F08D0F",
      "descriptionColor": "#FCE5CF",
      "yearColor": "#F08D0F",
      "details": {
        "name": "loanapp",
        "description": "Loan-App is a great Application that can be used by any customer for providing the loan. When a user apply for loan, they can able to view the Rate of intrest and other Details at the same time.",
        "role": "Full Stack",
        "year": "2019",
        "shape": "PSX.svg",
        "image": "camping-vw-van.png",
        "subImage": "camping-tree.png",
        "btnColor": "orange",
        "techList": {
          "frontend": [
            "F0-React.svg",
            "L0-JavaScript.svg",
            "F11-Bootstrap.svg",
            "L2-HTML5.svg",
            "L4-CSS3.svg",
          ],
          "backend": [
            "L5-Node_js.svg",
            "F10-Express_js.svg",
            // "F14-Passport_js.svg",
            "T9-MongoDB.svg",
            // "T10-Mongoose_js.png",
          ],
          "tech": [
            // "A2-Mapbox__API.svg"
            "T1-Firebase.svg"
          ]
        },
        "projectUrl": "https://react-loan-app-28502.firebaseapp.com/",
        "codeUrl": "https://github.com/SanuKumar/react-loan-app"
      },
      "shapes": [
        {
          "name": "portfolio",
          "id": 2,
          "pos": [
            [-43, 15, -15],
            [-22, -10, 1],
            [-8, 7, -1],
            [0, 20, -20],
            [8, 4.5, 6],
            [12, -9, 2],
            [65, 3, -40],
          ],
          "scale": [0.4, 0.7, 0.3, 0.2, 0.4, 0.4, 0.5],
          "materialId": 2
        }
      ]
    },
    {
      "name": "portfolio",
      "project": "bookrecord",
      "projectId": 4,
      "backgroundColor": "#027002",
      "titleColor": "#FA6BF9",
      "descriptionColor": "#ECD4F7",
      "yearColor": "#FA6BF9",
      "details": {
        "name": "bookrecord",
        "description": "Book record is a App for maintaining Record for the Read and Unread Books. User's can add different details on this so that he can have a note of Book",
        "role": "Front End",
        "year": "2018",
        "shape": "PSTriangle.svg",
        "image": "nature-bird.png",
        "subImage": "nature-flower.png",
        "btnColor": "pink",
        "techList": {
          "frontend": [
            "F0-React.svg",
            "L2-HTML5.svg",
            "L4-CSS3.svg",
            // "L3-Sass.svg"
          ]
        },
        "projectUrl": "https://book-record-ded8a.firebaseapp.com/",
        "codeUrl": "https://github.com/SanuKumar/bookscart"
      },
      "shapes": [
        {
          "name": "portfolio",
          "id": 3,
          "pos": [
            [-40, -7, -15],
            [-16, -10, -1],
            [-15, 4.5, 5],
            [-4, 5, -1],
            [10, -6, 6],
            [20, 18, -14],
            [52, 4, -30],
          ],
          "scale": [0.4, 0.5, 0.5, 0.3, 0.5, 1.2, 0.5],
          "materialId": 3
        }
      ]
    }
  ],
  about: [
    {
      "name": "about",
      "backgroundColor": "#000000",
      "noiseSphere": true
    }
  ]
}